import { FileManagerView } from "../../../redux/slices/fileManagerSlice";
import { ResourceType } from "../../../interfaces/general";
import { ReactComponent as ShieldDangerIcon } from "../../../assets/images/fileManager/shield-danger.svg";
import { ReactComponent as ShieldLoadingIcon } from "../../../assets/images/fileManager/shield-loading.svg";
import { ReactComponent as ShieldPassIcon } from "../../../assets/images/fileManager/shield-pass.svg";
import { isFolder, isTouchScreen } from "../../../scripts/helpers";

interface Props {
    resource: ResourceType;
    view: FileManagerView;
}

function AntivirusStatus({ resource, view }: Props) {
    const malwareRiskStatus = () => {
        switch (true) {
            case resource.malware_risk === null:
                return (
                    <ShieldLoadingIcon
                        data-tip="فایل در حال اسکن توسط آنتی ویروس‌ها است."
                        className={`h-auto fill-secondary-500 ${view === FileManagerView.list ? "w-[8px] lg:w-3" : "w-3"} ${resource.has_cover && "fill-white"}`}
                    />
                );

            case resource.malware_risk === 0:
                return (
                    <ShieldPassIcon
                        className={`h-auto ${view === FileManagerView.list ? "w-[8px] lg:w-3" : "w-3"} ${view === FileManagerView.list ? "fill-lime-300 lg:fill-lime-600" : resource.has_cover ? "fill-lime-300" : "fill-[#067306]"}`}
                    />
                );

            case resource.malware_risk !== null && resource.malware_risk! > 0:
                return (
                    <ShieldDangerIcon
                        data-tip={`این فایل توسط ${resource.malware_risk && resource.malware_risk * 100} درصد آنتی‌ویروس‌ها مخرب شناسایی شده است.`}
                        className={`h-auto fill-red-600 ${view === FileManagerView.list ? "w-[8px] lg:w-3" : "w-3"} ${resource.has_cover && "fill-red-500"}`}
                    />
                );
        }
    };

    return !isFolder(resource) && resource.malware_risk !== -1 ? (
        <div
            className={`flex items-center justify-center z-[2] ${view === FileManagerView.list ? (isTouchScreen() ? "size-[15px] rounded-[6px] shrink-0 bg-secondary-600 bg-opacity-80" : "size-5 rounded-[6px] shrink-0 bg-secondary-300") : resource.has_cover && "size-6 bg-secondary-600 rounded-[4px]"}`}
        >
            {malwareRiskStatus()}
        </div>
    ) : null;
}

export default AntivirusStatus;
